"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcButton_1 = __importDefault(require("../../button/AcButton"));
exports.AcStampButtonSetting = function (_a) {
    var settingButton = _a.settingButton, onClickSetting = _a.onClickSetting;
    return (react_1.default.createElement("div", { className: "position-absolute", style: { right: 0, top: 0, width: '30px', height: '30px' }, onClick: function (e) {
            e.stopPropagation();
        } },
        react_1.default.createElement(AcButton_1.default, { width: "28", height: "28", className: "p-0", variant: "link", onClick: onClickSetting }, settingButton || react_1.default.createElement("i", { className: "far fa-cog fa-fw text-secondary" }))));
};
exports.AcStampButtonSetting.displayName = 'AcStampButtonSetting';
//# sourceMappingURL=AcStampButtonSetting.js.map